import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from '@sb/library/button';
import { UtilityModule } from '@sb/library/utility';
import { EmptyStateComponent } from './empty-state.component';
import { SvgComponent } from '@sb/library/svg';

@NgModule({
    declarations: [
        EmptyStateComponent
    ],
    imports: [
        CommonModule,
        UtilityModule,
        ButtonModule,
        SvgComponent
    ],
    exports: [
        EmptyStateComponent
    ]
})
export class EmptyStateModule { }
